module.exports = __webpack_public_path__ + "img/com_pic4.a922bf2e.jpg";